export default __webpack_public_path__ + "static/media/mcgill-university-marked.8a2d1791.png";